export const GOOGLE_AUTH_TYPE = 'Google';
export const LEGACY_AUTH_TYPE = 'Legacy';
export const MS_AUTH_TYPE = 'MS';
